<template>
    <Icon>
        <template #component>
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <text x="10" y="20" font-size="20" fill="#4472C4" text-anchor="middle" font-style="italic" style="font-weight:500">AI</text>
            </svg>
        </template>
    </Icon>
</template>
<script setup>
    import Icon from '@ant-design/icons-vue';
</script>


<style scoped>

</style>